export const TENANT_COLUMNS = [
  { key: 'new', label: 'New', color: '#60a5fa' },
  { key: 'healthy', label: 'Healthy', color: '#10b981' },
  { key: 'at_risk', label: 'At Risk', color: '#f59e0b' },
  { key: 'critical', label: 'Critical', color: '#ef4444' },
  { key: 'churned', label: 'Churned', color: '#64748b' }
];

export const TENANT_FEATURES = [
  { key: 'has_created_audiences', label: 'Audiences' },
  { key: 'has_created_contacts', label: 'Contacts' },
  { key: 'has_sent_campaigns', label: 'Campaigns' },
  { key: 'has_created_templates', label: 'Templates' },
  { key: 'has_created_workflows', label: 'Workflows' },
  { key: 'has_created_neurons', label: 'Neurons' },
  { key: 'has_set_dns', label: 'DNS Setup' },
  { key: 'has_sent_sms', label: 'SMS' },
  { key: 'has_sent_mobi_push', label: 'Push Notifications' },
  { key: 'has_set_preferences', label: 'Preferences' },
  { key: 'has_made_email_payments', label: 'Email Payments' },
  { key: 'has_made_sms_payments', label: 'SMS Payments' }
];
